export const TRIGGER_TOUR_GUIDE_MODAL = 'TRIGGER_TOUR_GUIDE_MODAL';
export const TOUR_GUIDE_SCROLL_STEPS_INCREASE = 'TOUR_GUIDE_SCROLL_STEPS_INCREASE';
export const TOUR_GUIDE_SCROLL_STEPS_DECREASE = 'TOUR_GUIDE_SCROLL_STEPS_DECREASE';
export const RESET_SCROLL_STEPS = 'RESET_SCROLL_STEPS';
export const RESTART_TOUR_GUIDE = 'RESTART_TOUR_GUIDE'
